import React from 'react';

/**
 * Bloc des totaux de paie
 */
export function TotalsBlock({ totals }) {
  if (!totals) return null;

  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) return '0.00';
    return amount.toFixed(2);
  };

  return (
    <div className="payroll-totals-block">
      <div className="payroll-totals-grid">
        <div className="payroll-total-line">
          <span className="payroll-total-label">Salaire brut</span>
          <span className="payroll-total-value">{formatAmount(totals.brut)} €</span>
        </div>
        
        <div className="payroll-total-line">
          <span className="payroll-total-label">Total cotisations salariales</span>
          <span className="payroll-total-value payroll-total-negative">- {formatAmount(totals.total_employee_contribs)} €</span>
        </div>
        
        <div className="payroll-total-line payroll-total-intermediate">
          <span className="payroll-total-label">Net imposable</span>
          <span className="payroll-total-value">{formatAmount(totals.net_imposable)} €</span>
        </div>
        
        {totals.pas > 0 && (
          <div className="payroll-total-line">
            <span className="payroll-total-label">Prélèvement à la source (PAS)</span>
            <span className="payroll-total-value payroll-total-negative">- {formatAmount(totals.pas)} €</span>
          </div>
        )}
        
        <div className="payroll-total-line payroll-total-main">
          <span className="payroll-total-label">Net à payer</span>
          <span className="payroll-total-value">{formatAmount(totals.net_a_payer)} €</span>
        </div>
        
        <div className="payroll-total-separator"></div>
        
        <div className="payroll-total-line payroll-total-employer">
          <span className="payroll-total-label">Total charges patronales</span>
          <span className="payroll-total-value">{formatAmount(totals.total_employer_contribs)} €</span>
        </div>
        
        <div className="payroll-total-line payroll-total-cost">
          <span className="payroll-total-label">Coût total employeur</span>
          <span className="payroll-total-value">{formatAmount(totals.cout_total)} €</span>
        </div>
      </div>
    </div>
  );
}
